import { useGSAP } from "@gsap/react";
import { testimonials } from "../constants";
import { animateWithGsap } from "../utils/animations";

const Stars = ({ count }) => (
  <div className="flex gap-0.5 text-ferrari">
    {Array.from({ length: count }).map((_, i) => (
      <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01L12 2Z" />
      </svg>
    ))}
  </div>
);

const Testimonials = () => {
  useGSAP(() => {
    animateWithGsap("#temoignages .section-head", { y: 0, opacity: 1 });
    animateWithGsap(
      "#temoignages .testimonial-card",
      { y: 0, opacity: 1, stagger: 0.12 },
      { start: "top 80%" }
    );
  }, []);

  return (
    <section id="temoignages" className="section-padding bg-noir-900">
      <div className="section-container">
        <div className="section-head reveal">
          <span className="eyebrow">Ils nous font confiance</span>
          <h2 className="section-title">Ce que disent nos clients</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <figure key={t.name} className="testimonial-card card reveal flex flex-col">
              <Stars count={t.rating} />
              <blockquote className="mt-4 text-chrome-light text-sm leading-relaxed flex-1">
                « {t.text} »
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-white/10">
                <span className="font-semibold">{t.name}</span>
                <span className="block text-chrome-dark text-xs mt-0.5">{t.car}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
